import styled from 'styled-components'

export const Text = styled.p`
  margin-top: 12px;
  line-height: 24px;
`
